'use client';

import { cloneDemoSeed } from './demoData';
import type { Attendance, DemoData, GymSettings, Member, Payment, Routine, RoutineProgress } from './demoTypes';

const DATA_KEY = 'gymos.demo.data.v1';
export const DEMO_DATA_EVENT = 'gymos:demo-data-changed';

function canUseStorage() { return typeof window !== 'undefined'; }

export function initializeDemo(): DemoData {
  if (!canUseStorage()) return cloneDemoSeed();
  const stored = window.localStorage.getItem(DATA_KEY);
  if (stored) {
    try {
      const parsed = JSON.parse(stored) as DemoData;
      if (parsed.version === cloneDemoSeed().version) return parsed;
    } catch { /* replace invalid demo data */ }
  }
  const seed = cloneDemoSeed();
  window.localStorage.setItem(DATA_KEY, JSON.stringify(seed));
  return seed;
}

export function getDemoData(): DemoData { return initializeDemo(); }

export function saveDemoData(data: DemoData): void {
  if (!canUseStorage()) return;
  window.localStorage.setItem(DATA_KEY, JSON.stringify(data));
  window.dispatchEvent(new Event(DEMO_DATA_EVENT));
}

export function resetDemo(): DemoData {
  const seed = cloneDemoSeed();
  saveDemoData(seed);
  return seed;
}

export const getMembers = (): Member[] => getDemoData().members;
export const saveMembers = (members: Member[]) => saveDemoData({ ...getDemoData(), members });
export const getPayments = (): Payment[] => getDemoData().payments;
export const savePayments = (payments: Payment[]) => saveDemoData({ ...getDemoData(), payments });
export const getAttendances = (): Attendance[] => getDemoData().attendances;
export const saveAttendances = (attendances: Attendance[]) => saveDemoData({ ...getDemoData(), attendances });
export const saveRoutines = (routines: Routine[]) => saveDemoData({ ...getDemoData(), routines });
export const saveRoutineProgress = (routineProgress: RoutineProgress[]) => saveDemoData({ ...getDemoData(), routineProgress });
export const saveSettings = (settings: GymSettings) => saveDemoData({ ...getDemoData(), settings });
